<div id="energie-select">
  <div [class]="'dpe-field dpe-field-'+value+(selectable ? ' selectable' : '')" (click)="selectable ? selecting = !selecting : selecting = false">
    <div class="arrow">
      <span class="note">{{ value | classeEnergetique }}</span>
    </div>
  </div>


  @if (selecting) {
    <div class="scale">
      <input type="radio" id="dpe-field-CLASSE_ENERGETIQUE_A_PLUS_PLUS_PLUS" name="dpe" [value]="ClassEnergetiqueEnum.CLASSE_ENERGETIQUE_A_PLUS_PLUS_PLUS" [(ngModel)]="value"
        (ngModelChange)="radioChanged($event)">
      <label for="dpe-field-CLASSE_ENERGETIQUE_A_PLUS_PLUS_PLUS" (click)="value === ClassEnergetiqueEnum.CLASSE_ENERGETIQUE_A_PLUS_PLUS_PLUS ? hide(): true">
        <div class="arrow">
          <span class="note">{{ ClassEnergetiqueEnum.CLASSE_ENERGETIQUE_A_PLUS_PLUS_PLUS | classeEnergetique }}</span>
        </div>
      </label>
      <input type="radio" id="dpe-field-CLASSE_ENERGETIQUE_A_PLUS_PLUS" name="dpe" [value]="ClassEnergetiqueEnum.CLASSE_ENERGETIQUE_A_PLUS_PLUS" [(ngModel)]="value"
        (ngModelChange)="radioChanged($event)">
      <label for="dpe-field-CLASSE_ENERGETIQUE_A_PLUS_PLUS" (click)="value === ClassEnergetiqueEnum.CLASSE_ENERGETIQUE_A_PLUS_PLUS ? hide(): true">
        <div class="arrow">
          <span class="note">{{ ClassEnergetiqueEnum.CLASSE_ENERGETIQUE_A_PLUS_PLUS | classeEnergetique  }}</span>
        </div>
      </label>
      <input type="radio" id="dpe-field-CLASSE_ENERGETIQUE_A_PLUS" name="dpe" [value]="ClassEnergetiqueEnum.CLASSE_ENERGETIQUE_A_PLUS" [(ngModel)]="value"
        (ngModelChange)="radioChanged($event)">
      <label for="dpe-field-CLASSE_ENERGETIQUE_A_PLUS" (click)="value === ClassEnergetiqueEnum.CLASSE_ENERGETIQUE_A_PLUS ? hide(): true">
        <div class="arrow">
          <span class="note">{{ ClassEnergetiqueEnum.CLASSE_ENERGETIQUE_A_PLUS | classeEnergetique  }}</span>
        </div>
      </label>
      <input type="radio" id="dpe-field-CLASSE_ENERGETIQUE_A" name="dpe" [value]="ClassEnergetiqueEnum.CLASSE_ENERGETIQUE_A" [(ngModel)]="value"
        (ngModelChange)="radioChanged($event)">
      <label for="dpe-field-CLASSE_ENERGETIQUE_A" (click)="value === ClassEnergetiqueEnum.CLASSE_ENERGETIQUE_A ? hide(): true">
        <div class="arrow">
          <span class="note">{{ ClassEnergetiqueEnum.CLASSE_ENERGETIQUE_A | classeEnergetique  }}</span>
        </div>
      </label>
      <input type="radio" id="dpe-field-CLASSE_ENERGETIQUE_B" name="dpe" [value]="ClassEnergetiqueEnum.CLASSE_ENERGETIQUE_B" [(ngModel)]="value"
        (ngModelChange)="radioChanged($event)">
      <label for="dpe-field-CLASSE_ENERGETIQUE_B" (click)="value === ClassEnergetiqueEnum.CLASSE_ENERGETIQUE_B ? hide(): true">
        <div class="arrow">
          <span class="note">{{ ClassEnergetiqueEnum.CLASSE_ENERGETIQUE_B | classeEnergetique  }}</span>
        </div>
      </label>
      <input type="radio" id="dpe-field-CLASSE_ENERGETIQUE_INCONNUE" name="dpe" [value]="ClassEnergetiqueEnum.CLASSE_ENERGETIQUE_INCONNUE" [(ngModel)]="value"
        (ngModelChange)="radioChanged($event)">
      <label for="dpe-field-CLASSE_ENERGETIQUE_INCONNUE" (click)="value === ClassEnergetiqueEnum.CLASSE_ENERGETIQUE_INCONNUE ? hide(): true">
        <div class="arrow">
          <span class="note">{{ ClassEnergetiqueEnum.CLASSE_ENERGETIQUE_INCONNUE | classeEnergetique }}</span>
        </div>
      </label>
    </div>
  }
</div>
